import { useEffect, useContext, useState } from "react";
import Swal from "sweetalert2";
import { postEmailCompAndMotiv } from "../../API/Employee/MYCO";
import { motivationsAvaliation, wheelCollaboratorTranslate } from "../../i18n/translatedMessages";
import { useIntl } from "react-intl";
import { ChatIcon, MotivacionesIcon } from "../../Icons/CollaboratorsIcons";
import { CompanyContext } from "../../Store/CompanyContext";
import { getMotivations, patchMotivations } from "../../API/Analytics/MYCO";
import Loading from "../../Components/Loading/Loading";
import MotivationsAbilitiesQuotation from "./Components/MotivationsAbilitiesQuotation/MotivationsAbilitiesQuotation";
import { motivationsListES, motivationsListPT } from "../../i18n/messages/Lists/motivationsList";
import CustomTooltip from "./Components/CustomTooltip/CustomTooltip";
import { MdKeyboardArrowDown } from "react-icons/md";

import "./Motivations.sass";

const tooltipMessages = {
  "PT-BR":
    "Você pode optar por mostrar aos recrutadores os resultados de sua autoavaliação ou aqueles certificados pela Myco. Caso você já tenha feito o teste, recomendamos a segunda opção, pois ela é certificada e vai te auxiliar no seu processo.",
  ES: "Puedes elegir mostrar a los reclutadores, los resultados de tu autoevaluación o los certificados por Myco. En caso de que hayas realizadado el test, te recomendamos la segunda opción, ya que está certificada y te ayudará en tu proceso.",
};

const B2EMotivaciones = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  const language = useIntl().locale;
  const motivationsList = language === "PT-BR" ? motivationsListPT : motivationsListES;
  const { store, actions } = useContext(CompanyContext);
  const tooltip = tooltipMessages[language];

  const [loading, setLoading] = useState(false);

  const [isExpanded, setIsExpanded] = useState({
    myCo: false,
    collab: false,
  });

  const defaultMotivations = {
    career: null,
    safety: null,
    isActive: false,
    prestige: null,
    commitment: null,
    economic_aspect: null,
    job_satisfaction: null,
    skills_development: null,
    target_orientation: null,
    autonomy_versatility: null,
    business_orientation: null,
    professional_balance: null,
    professional_proyect: null,
    conceptual_orientation: null,
    innovation_orientation: null,
    management_orientation: null,
    orientation_type_work_performed: null,
    orientation_interpersonal_relations: null,
  };

  const [motivations, setMotivations] = useState({
    myCo: { ...defaultMotivations },
    collab: { ...defaultMotivations },
  });

  const [inputData, setInputData] = useState(motivationsListES);

  const [inputWarningsCollab, setInputWarningsCollab] = useState({});
  const [inputWarningsMyCo, setInputWarningsMyCo] = useState({});

  const handleAccordionToggle = (section) => {
    setIsExpanded((prevExpanded) => ({
      ...prevExpanded,
      [section]: !prevExpanded[section],
    }));
  };

  const areCollabInputsValid = () => {
    const collabInputKeys = Object.keys(motivations.collab).filter((key) => key !== "isActive");
    const collabInputValues = collabInputKeys.map((key) => motivations.collab[key]);

    return collabInputValues.every((value) => value !== null && !isNaN(parseFloat(value)) && value >= 1 && value <= 10);
  };

  const areMyCoInputsValid = () => {
    const myCoInputKeys = Object.keys(motivations.myCo).filter((key) => key !== "isActive");
    const myCoInputValues = myCoInputKeys.map((key) => motivations.myCo[key]);

    return myCoInputValues.every((value) => value !== null && !isNaN(parseFloat(value)) && value >= 1 && value <= 10);
  };

  const handleData = (section, name, value) => {
    const parsedValue = parseFloat(value);

    if (value === "") {
      setMotivations((prevMotivations) => ({
        ...prevMotivations,
        [section]: {
          ...prevMotivations[section],
          [name]: undefined,
        },
      }));
      if (section === "collab") {
        setInputWarningsCollab((prevWarnings) => ({
          ...prevWarnings,
          [name]: true,
        }));
      } else if (section === "myCo") {
        setInputWarningsMyCo((prevWarnings) => ({
          ...prevWarnings,
          [name]: true,
        }));
      }
    } else if (!isNaN(parsedValue) && parsedValue >= 1 && parsedValue <= 10) {
      setMotivations((prevMotivations) => ({
        ...prevMotivations,
        [section]: {
          ...prevMotivations[section],
          [name]: parsedValue,
        },
      }));
      if (section === "collab") {
        setInputWarningsCollab((prevWarnings) => ({
          ...prevWarnings,
          [name]: false,
        }));
      } else if (section === "myCo") {
        setInputWarningsMyCo((prevWarnings) => ({
          ...prevWarnings,
          [name]: false,
        }));
      }
    } else {
      if (section === "collab") {
        setInputWarningsCollab((prevWarnings) => ({
          ...prevWarnings,
          [name]: true,
        }));
      } else if (section === "myCo") {
        setInputWarningsMyCo((prevWarnings) => ({
          ...prevWarnings,
          [name]: true,
        }));
      }
      setMotivations((prevMotivations) => ({
        ...prevMotivations,
        [section]: {
          ...prevMotivations[section],
          [name]: undefined,
        },
      }));
    }
  };

  const handleSendQuotation = async () => {
    await postEmailCompAndMotiv(user.id)
      .then(() => {
        Swal.fire({
          title: "👌",
          text: "Nuestro equipo se pondra en contacto a la brevedad!",
          icon: "success",
          confirmButtonText: "Ok",
        });
      })
      .catch(() => {
        actions.setResponseStatus(false);
        actions.setMessageResponseStatus("Ha ocurrido un error!");
        actions.setShowModalResponseStatus(true);
      });
  };

  const handleSend = async () => {
    const data = [
      {
        myco: { ...defaultMotivations, ...motivations.myCo },
        colab: { ...defaultMotivations, ...motivations.collab },
      },
    ];

    try {
      setLoading(true);
      await patchMotivations(user.candidateId, data); //userId = candidate.id
      setLoading(false);
      Swal.fire({
        icon: "success",
        title: "¡Éxito!",
        text: "Los datos han sido guardados con éxito.",
        confirmButtonText: "OK",
      });
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    const fetchEmployer = async () => {
      const tempMotivations = await getMotivations(user.candidateId);
      setMotivations({
        myCo: tempMotivations.items[0].myco,
        collab: tempMotivations.items[0].colab,
      });
    };
    fetchEmployer();
  }, []);

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className="container-fluid sideMenuSeparator px-5">
          <div className="row mb-4 align-items-center">
            <div className="col-2">
              <span className="title-icon p-2 m-auto">
                <MotivacionesIcon size={20} />
              </span>
            </div>
            <div className="col-10">
              <h1>{wheelCollaboratorTranslate.motivacions}</h1>
              <p className="description-section">{motivationsAvaliation.motivationHeaderText}</p>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="accordion mb-4">
              <div className="accordion-header" onClick={() => handleAccordionToggle("collab")}>
                <div className={`purple-box p-3 d-flex align-items-center justify-content-between`}>
                  {motivationsAvaliation.motivationOption1}
                  <MdKeyboardArrowDown
                    size={35}
                    style={{
                      transform: isExpanded.collab ? "rotate(0deg)" : "rotate(180deg)",
                      transition: "transform 0.3s ease-in-out",
                    }}
                  />
                </div>
              </div>
              {isExpanded.collab && (
                <div className="accordion-body inputs-motivations content-border">
                  <div className="m-4">
                    <span>{motivationsAvaliation.motivationOption1Text}</span>
                    <div className="row mt-5">
                      {motivationsList.map((item, index) => (
                        <div className="col-md-4 mb-3" key={index}>
                          <div className="d-flex">
                            <p style={{ marginBottom: 0 }} className="me-1">
                              {item.title}
                            </p>
                            <CustomTooltip msg={item.desc}>
                              <ChatIcon />
                            </CustomTooltip>
                          </div>
                          <input
                            type="text"
                            value={motivations.collab[item.name] !== undefined ? motivations.collab[item.name] : ""}
                            name={item.name}
                            className="form-control"
                            onChange={(e) => handleData("collab", item.name, e.target.value)}
                          />
                          {inputWarningsCollab[item.name] && <div style={{ color: "red" }}>{inputWarningsCollab[item.name] ? motivationsAvaliation.motivationInputError : ""}</div>}
                        </div>
                      ))}
                    </div>
                    <div className="form-check my-4">
                      <input
                        className="form-check-input"
                        checked={motivations.collab.isActive}
                        type="checkbox"
                        disabled={!areCollabInputsValid()}
                        onChange={() => {
                          const newMotivations = { ...motivations };
                          if (!newMotivations.collab.isActive) {
                            newMotivations.collab.isActive = true;
                            newMotivations.myCo.isActive = false;
                          } else {
                            newMotivations.collab.isActive = false;
                          }
                          setMotivations(newMotivations);
                        }}
                      />
                      <label className="form-check-label">{motivationsAvaliation.motivationShowColab}</label>
                      <CustomTooltip msg={tooltip}>
                        <ChatIcon />
                      </CustomTooltip>
                    </div>
                    <button
                      className="btn rounded-pill mt-3"
                      onClick={handleSend}
                      style={{
                        backgroundColor: "#7A6BE8",
                        color: "white",
                        width: "200px",
                      }}
                      disabled={
                        (!motivations.collab.isActive && !motivations.myCo.isActive) ||
                        Object.values(inputWarningsCollab).some((warning) => warning) ||
                        Object.values(motivations.collab).some((value) => value === null)
                      }
                    >
                      Guardar
                    </button>
                  </div>
                </div>
              )}
            </div>

            <div className="myco-accordion mt-3 mb-5">
              <div className="accordion-header" onClick={() => handleAccordionToggle("myCo")}>
                <div className="blue-box p-3 d-flex align-items-center justify-content-between">
                  {motivationsAvaliation.motivationOption2}
                  <MdKeyboardArrowDown
                    size={35}
                    style={{
                      transform: isExpanded.myCo ? "rotate(0deg)" : "rotate(180deg)",
                      transition: "transform 0.3s ease-in-out",
                    }}
                  />
                </div>
              </div>

              {isExpanded.myCo && (
                <div className="accordion-body inputs-motivations content-border">
                  <div className="m-4">
                    <span>{motivationsAvaliation.motivationOption2Text}</span>

                    <div className="row mt-5">
                      {motivationsList.map((item, index) => (
                        <div className="col-md-4 mb-3" key={index}>
                          <div className="d-flex">
                            <p style={{ marginBottom: 0 }} className="me-1">
                              {item.title}
                            </p>
                            <CustomTooltip msg={item.desc}>
                              <ChatIcon />
                            </CustomTooltip>
                          </div>
                          <input
                            type="text"
                            value={motivations.myCo[item.name] !== undefined ? motivations.myCo[item.name] : ""}
                            className="form-control"
                            onChange={(e) => handleData("myCo", item.name, e.target.value)}
                          />
                          {inputWarningsMyCo[item.name] && <div style={{ color: "red" }}>{inputWarningsMyCo[item.name] ? motivationsAvaliation.motivationInputError : ""}</div>}
                        </div>
                      ))}
                    </div>
                    <div className="form-check my-4">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        disabled={!areMyCoInputsValid()}
                        checked={motivations.myCo.isActive}
                        onChange={() => {
                          const newMotivations = { ...motivations };
                          if (!newMotivations.myCo.isActive) {
                            newMotivations.myCo.isActive = true;
                            newMotivations.collab.isActive = false;
                          } else {
                            newMotivations.myCo.isActive = false;
                          }
                          setMotivations(newMotivations);
                        }}
                      />
                      <label className="form-check-label me-1">{motivationsAvaliation.motivationShowMyCo}</label>
                      <CustomTooltip msg={tooltip}>
                        <ChatIcon />
                      </CustomTooltip>
                    </div>
                    <button
                      className="btn rounded-pill mt-3"
                      style={{
                        backgroundColor: "#7A6BE8",
                        color: "white",
                        width: "200px",
                      }}
                      onClick={handleSend}
                      disabled={
                        (!motivations.collab.isActive && !motivations.myCo.isActive) ||
                        Object.values(inputWarningsMyCo).some((warning) => warning) ||
                        Object.values(motivations.myCo).some((value) => value === null)
                      }
                    >
                      Guardar
                    </button>
                  </div>
                </div>
              )}
            </div>
            <MotivationsAbilitiesQuotation quotationButton={handleSendQuotation} pdfDownload={"https://assets.mydna.company/Motivaciones-cotizar.pdf"} />
          </div>
        </div>
      )}
    </>
  );
};
export default B2EMotivaciones;
